import React from 'react';
import overview from './overview.json';
import classic from './assets/cards/classic.png';
import silver from './assets/cards/silver.png';
import gold from './assets/cards/gold.png';
import platinum from './assets/cards/platinum.png';
import './overview.scss';

const cardImages = { classic, silver, gold, platinum };

export default function MembershipOverview() {
  return (
    <>
      <section className="asr-membership-intro" aria-labelledby="asr-membership-intro-title">
        <h2 id="asr-membership-intro-title">{overview.intro.title}</h2>
        {overview.intro.paragraphs.map((paragraph) => <p className='fs-16' key={paragraph}>{paragraph}</p>)}
      </section>
      <div className="asr-membership-levels" role="region" aria-label="会员等级概览">
        {overview.cards.map((card) => (
          <article className="asr-tier-summary" key={card.id} aria-labelledby={`asr-summary-${card.id}`}>
            <p className="asr-tier-summary__image">
              <img src={cardImages[card.id]} alt={`雅星会 ${card.name} 会员卡`} width={card.imageWidth} height={card.imageHeight} />
            </p>
            <h3 id={`asr-summary-${card.id}`}>{card.name}</h3>
            <p className="asr-tier-summary__requirement">{card.requirement}</p>
            <table className="asr-tier-summary__list" role="presentation" style={{ width: card.listWidth }}>
              <colgroup><col style={{ width: card.markerWidth }} /><col /></colgroup>
              <tbody>
                {card.rows.map((row, index) => (
                  <tr key={index} aria-hidden={!row.text.trim() ? 'true' : undefined}>
                    <td className="asr-tier-summary__check" style={{ color: row.markerColor }} aria-hidden="true">{row.checked ? '✓' : '\u00a0'}</td>
                    <td>{row.italic ? <em>{row.text}</em> : row.text}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {card.bottomSpace && <p className="asr-tier-summary__space" aria-hidden="true">&nbsp;</p>}
          </article>
        ))}
      </div>
    </>
  );
}
